<template>
    <div class="tw-block tw-no-underline tw-whitespace-nowrap" :class="[ sharedClasses, isActive ? activeClass : disabledClass ]" @click.prevent="onClick">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "TabButton",

    props: {
        activeClass: {
            type: String,
            default: 'tw-border-b-2 tw-border-pia-red tw-cursor-default'
        },
        disabledClass: {
            type: String,
            default: 'tw-text-gray-400 tw-cursor-pointer'
        },
        sharedClasses: {
            type: String,
            default: 'tw-font-bold tw-py-2 tw-px-4'
        },
        for: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isActive: false,
            useHashes: true
        }
    },

    computed: {
        href() {
            if(this.useHashes) {
                return '#' + this.for;
            } else {
                return null;
            }
        }
    },

    methods: {
        toggle(value) {
            this.isActive = value;
        },

        onClick() {
            if(this.useHashes) {
                window.location.hash = this.for;
            }

            this.$emit('click');
        }
    }
}
</script>

<style>

</style>